module.exports = __webpack_public_path__ + "media/images/homelight-8702afc1576f045f4473b0902aa1ed6f.png";